// Import CSS
import '../css/load.scss';

import initCantonalGuide from './cantonal-guide';
import List from 'list.js';

// Your JavaScript code here

(function ($) {
    const $win = $(window);
    const $doc = $(document);

    initWeglotSwitcherIds();
    initAccountDocuments();
    initHeaderMenuToggler();
    initChipLogic();
    initListArticles('list-articles');
    initGuideModal();
    initCantonalGuide();
    initFaqFilters();
    initFaqAccordion();

    function initWeglotSwitcherIds() {
        const switchers = document.querySelectorAll('.country-selector');

        if (!switchers.length) {
            return;
        }

        switchers.forEach((switcher, index) => {
            const input = switcher.querySelector('.weglot_choice');
            const label = switcher.querySelector('.wgcurrent[for]');

            if (!input || !label) {
                return;
            }

            const uniqueId = `weglot-switcher-${index + 1}`;

            input.id = uniqueId;
            label.setAttribute('for', uniqueId);
        });
    }

    function initAccountDocuments() {
        const container = document.querySelector('.js-account-documents');

        if (!container) {
            return;
        }

        const toggles = container.querySelectorAll('[data-account-toggle]');
        const panels = document.querySelectorAll('[data-account-panel]');

        if (!toggles.length || !panels.length) {
            return;
        }

        toggles.forEach((toggle) => {
            toggle.addEventListener('click', function () {
                const target = this.getAttribute('data-account-toggle');

                toggles.forEach((button) => {
                    const isActive = button === this;
                    button.classList.toggle('is-active', isActive);
                    button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
                });

                panels.forEach((panel) => {
                    panel.classList.toggle('is-open', panel.getAttribute('data-account-panel') === target);
                });
            });
        });
    }

    function addOverlay(ovElement) {
        const $overlay = $(`${ovElement}`);
        if (!$overlay.length) {
            return;
        }

        $('body').addClass('no-scroll');
        $overlay.addClass('active');
    }

    function removeOverlay(ovElement) {
        const $overlay = $(`${ovElement}`);
        if (!$overlay.length) {
            return;
        }

        $('body').removeClass('no-scroll');
        $overlay.removeClass('active');
    }

    function initHeaderMenuToggler() {
        if (!$('.header__menu-toggle').length) {
            return;
        }

        const $header = $('.header__container');

        $('.header .header__menu-toggle').on('click', function (e) {
            $(this).closest('.header__container').toggleClass('menu-open');
            addOverlay('.app-loader-overlay');
            e.preventDefault();
        });

        $('.header__menu-close svg').on('click', function (e) {
            $('.header__container').toggleClass('menu-open');
            e.preventDefault();
            removeOverlay('.app-loader-overlay');
        });

        $doc.mouseup(function (e) {
            if ($header.hasClass('menu-open')) {
                if (!$header.is(e.target) && $header.has(e.target).length === 0) {
                    $header.removeClass('menu-open');
                    removeOverlay('.app-loader-overlay');
                }
            }
        });
    }

    function initChipLogic() {
        if (!$('.section-articles').length) {
            return;
        }

        $('input[name="field-category[]"]').on('change', function () {
            if ($(this).val() !== 'All') {
                $('.input--chips input[value="All"]').prop('checked', false);
            } else {
                $('.input--chips').find('input[value!="All"]').prop('checked', false);
            }
        });
    }

    function initListArticles(elementSelector) {
        if (!$('.section-articles').length) {
            return;
        }

        let options = {
            valueNames: [{ data: ['ljs-article'] }],
            listClass: 'ljs-container'
        };

        let list = new List(elementSelector, options);

        $('input[name="field-category[]"]').on('change', function () {
            let selectedArticleCategories = $('input[name="field-category[]"]:checked')
                .map(function (_, el) {
                    return $(el).val();
                })
                .get();

            if (selectedArticleCategories.includes('All') || selectedArticleCategories.length === 0) {
                list.filter();
            } else {
                list.filter(function (item) {
                    let allCategoriesString = item.values()['ljs-article'] || '';
                    let allCategoriesArray = allCategoriesString
                        .split(',')
                        .map((category) => category.trim())
                        .filter(Boolean);

                    return selectedArticleCategories.some((category) => allCategoriesArray.includes(category));
                });
            }
        });
    }

    function initGuideModal() {
        const $modal = $('#guide-modal');
        const $triggers = $('.js-guide-trigger');
        const $overlay = $('.app-loader-overlay');

        if (!$modal.length || !$triggers.length || !$overlay.length) {
            return;
        }

        const $closeButtons = $modal.find('.guide-modal__close');

        const openModal = () => {
            $modal.addClass('is-active').attr('aria-hidden', 'false');
            $overlay.css('z-index', '999997');
            addOverlay('.app-loader-overlay');
        };

        const closeModal = () => {
            $modal.removeClass('is-active').attr('aria-hidden', 'true');
            $overlay.css('z-index', '101');
            removeOverlay('.app-loader-overlay');
        };

        $triggers.on('click', function (event) {
            event.preventDefault();
            openModal();
        });

        $closeButtons.on('click', closeModal);

        $overlay.on('click', function () {
            if ($modal.hasClass('is-active')) {
                closeModal();
            }
        });

        $doc.on('keydown', function (event) {
            if (event.key === 'Escape' && $modal.hasClass('is-active')) {
                closeModal();
            }
        });
    }

    function initFaqFilters() {
        const container = document.querySelector('.faq');

        if (!container) {
            return;
        }

        const buttons = container.querySelectorAll('.faq-filter-btn');
        const sections = container.querySelectorAll('[data-faq-section]');

        if (!buttons.length || !sections.length) {
            return;
        }

        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const filter = button.getAttribute('data-filter');

                buttons.forEach((item) => {
                    const isActive = item === button;
                    item.classList.toggle('active', isActive);
                    item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
                });

                sections.forEach((section) => {
                    const shouldShow = filter === 'all' || section.getAttribute('data-faq-section') === filter;

                    section.hidden = !shouldShow;
                });
            });
        });
    }

    function initFaqAccordion() {
        const items = document.querySelectorAll('.faq-item');

        if (!items.length) {
            return;
        }

        items.forEach((item) => {
            const button = item.querySelector('.faq-question');
            const answer = item.querySelector('.faq-answer');

            if (!button || !answer) {
                return;
            }

            button.addEventListener('click', () => {
                const isOpen = item.classList.toggle('is-open');

                button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                answer.hidden = !isOpen;
            });
        });
    }


})(jQuery);
